module.exports = __webpack_public_path__ + "img/smart-dark.9ed0f644.svg";